var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"headCon flex-row"},[_c('p',[_vm._v(_vm._s(_vm.policyName))]),_c('img',{staticClass:"backIcon",attrs:{"src":require("@/assets/images/mobile/return.png"),"alt":""},on:{"click":_vm.back}})]),_c('div',{staticClass:"policyContent",domProps:{"innerHTML":_vm._s(_vm.policyContent.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }